<div class="contentFullVerticalHeight halfVerticalHeight">
    <div class="container">
        <div id="square-container" [innerHTML]='"copy.html.FIBDestination.DestinationCopy"|copy|async'></div>

        <!-- DOWNLOAD LINK TEST -->
        <a href="https://content.travelhq.com/activate-elevate/assets/images/activate-kentucky.webp" download>Download File</a>
    </div>
</div>